import { render, staticRenderFns } from "./demandsHeader.vue?vue&type=template&id=2a0ddb88&scoped=true"
import script from "./demandsHeader.vue?vue&type=script&lang=js"
export * from "./demandsHeader.vue?vue&type=script&lang=js"
import style0 from "./demandsHeader.vue?vue&type=style&index=0&id=2a0ddb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ddb88",
  null
  
)

export default component.exports